var $ = require('jquery');
/**
 * Notification Flyout
 */
(function(){

    var flyout = angular.module('diy.notification.flyout', ['ngSanitize', 'diy.notification']);

    diy.angular.loadFactories(flyout, ['diyl10n']);
    diy.angular.loadDirectives(flyout, [ 'diynotification' ]);

    flyout.filter('isEmpty', function() {
        return $.isEmptyObject;
    });

    flyout.controller('NotificationFlyoutCtrl', [
        '$scope', '$timeout', 'ntfApi', function($scope, $timeout, ntfApi) {

        /**
         * Refreshes the squeeze box + scrollbar when view changes
         */
        var refreshScroller = function() {
            // We use timeout to update the squeezebox after content has stabilized
            // and Angular has finished rendering the elements. We don't have
            // ngAnimate in 1.0.5 so we can't hook to ngShow
            $timeout(function() {
                diy.editor.notifications.notificationCenter.refreshScroller();
            });
        };

        $scope.categories = {};
        $scope.notifications = {};

        $scope.categories = jimdoData.notification.categories;

        var formatNotifications = function() {
            if (!ntfApi.notifications) {
                return;
            }
            var formattedNotification = {};
            $.each($scope.categories, function(i, cat) {
                cat.permitDeleteAll = false;
            });
            $.each(ntfApi.notifications, function(i, model) {
                if (model.getDeleted()) {
                    return true;
                }
                if (!formattedNotification[model.getCategory()]) {
                    formattedNotification[model.getCategory()] = [];
                }
                if (!model.getSticky()) {
                    permitDeleteAll(model.getCategory());
                }
                formattedNotification[model.getCategory()].push(model);
                return true;
            });
            $scope.notifications = formattedNotification;
        };

        var permitDeleteAll = function(category) {
            $.each($scope.categories, function(i, cat) {
                if (cat.id == category) {
                    cat.permitDeleteAll = true;
                }
            });
        };

        var notificationUpdateHandler = function() {
            formatNotifications();
            refreshScroller();
        };

        $scope.$watchCollection(function() { return ntfApi.notifications; }, notificationUpdateHandler);
        $scope.$on('notifications-changed', notificationUpdateHandler);

        ntfApi.loadNotifications();

        $scope.notificationAction = function(notif) {
            if (typeof notif.globalAction === 'function') {
                if (diy.tracking) {
                    diy.tracking.addEventSuppression('diy-editor-notification-center-closed');
                }
                $(document).trigger('diy-editor-generic-sectionAccessed', {
                    sectionCodeName: 'notificationClicked',
                    propName: notif.getName()
                });

                diy.editor.notifications.notificationCenter.hideLayer();

                notif.globalAction();
            } else if (typeof notif.globalAction === 'boolean' && notif.globalAction === false) {
                $(document).trigger('diy-editor-generic-sectionAccessed', {
                    sectionCodeName: 'notificationClicked',
                    propName: notif.getName()
                });
            } else {
                return;
            }
        };

        $scope.$watch('getUnreadCount()', function() {
            //HACK: at the first call the notification center is not yet exposed
            // on the global scope, because that's done after the first render
            $timeout(function() {
                diy.editor.notifications.notificationCenter.updateUnreadCountBubble($scope.getUnreadCount());
            });
        });

        // Used by flyout
        $scope.getUnreadCount = function() {
            return ntfApi.getUnreadCount();
        };

        // Used by flyout notification directive
        $scope.deleteNotification = function(id) {
            ntfApi.deleteNotification(id);
        };

        // Used by flyout
        $scope.deleteNotificationByCategory = function(category) {
            ntfApi.deleteNotificationByCategory(category);
        };
    }]);

    /*
     * We configure the location service to use html5mode, which avoids a nasty
     * bug where angular would prepend a slash to the hashbang
     * (e.g. #/hm:cc-sa-item-elements), breaking the existing history manager
     * This avoids hacking the angular.js file with the "remove forwardslash" patch
     * (see the file in the folder where angular.js resides)
     */
    flyout.config(['$locationProvider', function($locationProvider) {
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }]);

    //TODO: put this template in a separate html file
    flyout.run(['$templateCache', 'diyl10n', function($templateCache, diyl10n) {

        $templateCache.put('notificationFlyout.html',
            '<div class="notificationCenter-wrapper" ng-hide="notifications | isEmpty">' +
                '<div class="category" ng-repeat="cat in categories" ' +
                    'ng-if="notifications[cat.id].length > 0">' +
                    //TODO: abstract squeezebox markup
                    '<div class="diye-collapsible-category-header">' +
                        '<div class="diye-collapsible-category-positioned">' +
                            '<div class="diye-collapsible-category-title">' +
                                '<span ng-bind-html="cat.label"></span> ' +
                                '<span class="result-count">({{notifications[cat.id].length}})</span>' +
                            '</div>' +
                            '<a ng-show="cat.permitDeleteAll" style="position:absolute;right:55px;top:5px;" '+
                                'class="close-icon ui-icon ui-icon-close-small" title="' + diyl10n('notifications.deleteAll') + '"'+
                                'ng-click="deleteNotificationByCategory(cat.id)"></a>' +
                            '<div class="diye-collapsible-category-pointer"></div>' +
                            '<div class="diye-collapsible-category-arrow"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="diye-collapsible-category-content" >' +

                        '<ul class="notifications">' +
                            '<li diynotification class="notification" ng-repeat="notif in notifications[cat.id]" >' +
                            '</li>' +
                        '</ul>' +

                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="no-notifications-wrapper" ng-show="notifications | isEmpty">' +
                '<div class="no-notifications">' +
                    '<h3 class="subheading">' + diyl10n('notifications.zeroNotifications') + '</h3>' +
                '</div>' +
            '</div>'
        );
    }]);
}())



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/notification/flyout-module.js
 ** module id = 676
 ** module chunks = 0
 **/